export default cart => (cart ? cart.reduce((total, cartItem) => total + cartItem.quantity, 0) : 0);
